import React from 'react';
import { graphql, useFragment } from 'react-relay';
import type { KeyCell$key } from '@atlassian/jira-relay/src/__generated__/KeyCell.graphql';

type Props = {
	project: KeyCell$key;
};

export const KeyCell = ({ project }: Props): React.JSX.Element => {
	const { key } = useFragment(
		graphql`
			fragment KeyCell on JiraProject {
				key
			}
		`,
		project,
	);

	return <>{key}</>;
};
